export default __webpack_public_path__ + "static/media/leaderboard.aab34c97.svg";